//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  data() {
    return {
      showModel: false,
      sizeval: "",
      size: "",
      size_error: "",
      emailVal: "",
      emailValError: "",
      phoneVal: "",
      phoneValError: "",
      clicked: false,
      option: false,
      email: true,
      sms: false,
      sku: "",
    };
  },
  props: ["Psize", "name"],
  methods: {
    select_size: function(item) {
      this.sizeval = item.configrable_atribute_value;
      this.sku = item.sku;
      this.clicked = true;
      this.size_error = "";
    },
    options: function(opt) {
      if (opt === "email") {
        this.sms = false;
        this.email = true;
        this.phoneVal = "";
      } else if (opt === "SMS") {
        this.sms = true;
        this.email = false;
        this.emailVal = "";
      }
    },
    mobile_no: function() {
      var phoneno = /^([9867]{1})([1234567890]{1})([0-9]{8})$/;
      if (this.phoneVal.match(phoneno)) {
        this.phoneValError = "";
      } else {
        this.phoneValError = "Please enter valid number";
      }
    },
    email_valid: function() {
      var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.emailVal.match(email)) {
        this.emailValError = "";
      } else {
        this.emailValError = "Please enter valid Email";
      }
    },
    insertNotify: function() {
      if (this.sizeval === "") {
        this.size_error = "Please Select Size";
        return false;
      } else {
        this.size_error = "";
      }
      if ((this.phoneVal != "" || this.emailVal != "") && this.sizeval != "") {
        var form = new FormData();
        form.append("phone", this.phoneVal);
        form.append("sku", this.sku);
        form.append("email", this.emailVal);
        form.append("size", this.sizeval);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        this.$store.state.list.page_loader = true;
        axios
          .post(this.$store.state.list.cart_api_url + "/stockalert", form, config)
          .then((response) => {
            if (response.data.success == true) {
              this.showModel = false;
              this.$store.state.list.page_loader = false;
              this.phoneVal = ""
              this.emailVal = ""
              this.sizeval = ""
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
            }
          });
      } else {
        if (this.email === true) {
          this.email_valid();
        } else if (this.sms === true) {
          this.mobile_no();
        }
      }
    },
  },
};
